<div data-testid="spu-manager-page" class="spu-manager-header px-6 pt-6">
  <h2 class="text-2xl font-semibold text-gray-800 mb-3">
    {{ "goods.spu.title" | translate }}
  </h2>
  <div class="flex">
    @for (tab of spuTabs; track tab.value; let i = $index) {
      <button
        [attr.data-testid]="'spu-manager-tab-' + tab.value"
        type="button"
        [disabled]="tab.disabled"
        [class]="
          'px-4 py-2 text-sm font-medium border-b-2 ' +
          (tab.disabled
            ? 'border-transparent text-gray-400 cursor-not-allowed opacity-50'
            : activeTab === tab.value
              ? 'border-blue-500 text-blue-600'
              : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300')
        "
        (click)="onTabChange({ index: i })"
      >
        {{ tab.labelKey | translate }}
      </button>
    }
  </div>
</div>
<router-outlet></router-outlet>
